import { getFullName } from '@/shared/lib';

/** Части ФИО оператора: строка состава группы и строка окна выбора берут их из разных ответов */
type EmployeeNameParts = {
  firstName?: string | null;
  lastName?: string | null;
  middleName?: string | null;
};

/** ФИО оператора в строке состава группы и в окне выбора операторов */
export const getEmployeeName = (employee: EmployeeNameParts) =>
  getFullName(employee.firstName, employee.lastName, employee.middleName);
